import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter, map } from 'rxjs/operators';

import { AuthService } from '@core';

export const roleGuard: CanActivateFn = () => {
  return inject(AuthService).user().pipe(
    map(user => user.roles?.includes('admin')),
    filter(Boolean)
  );
};
